import React from 'react'
import { Fade } from "react-awesome-reveal";
import './Hero.css'
import HeroImg from './images/JMF Hero.jpg'
import backgroundVideo from './video/video.mp4'

const Hero = () => {
  return (
    <div className='mt-16 pt-2' id='hero'>
        <img src={HeroImg} />
      <div className='content'>
        </div>
    </div>
  )
}

export default Hero
